import React, { useEffect } from "react";
import { Crisp as CrispSDK } from "crisp-sdk-web";
import { crispID } from "@/constants";

export default function (): React.ReactNode {
    useEffect(() => {
        CrispSDK.configure(crispID);
    }, []);

    return <></>;
}
